import React from 'react';

const LoadingPage = () => {
  return <div>Loading...</div>;
};

export default LoadingPage;
